import React from 'react';
import logoSrc from '../../src/styles/logo.png';

interface LogoProps {
  size?: number;
  className?: string;
}

export default function Logo({ size = 28, className = '' }: LogoProps) {
  return (
    <img
      src={logoSrc}
      alt="RevertAI"
      width={size}
      height={size}
      className={`object-contain ${className}`}
    />
  );
}
